// Wrapper around the canonical `states` registry with lending-scope helpers.
// The registry itself lives in `src/data/states.ts`. This file just adds
// convenience predicates used by programmatic routes, the sitemap, and the
// lead form's state selector.
import { states, type StateInfo } from "./states";

// Every state in `states.ts` is part of our business-purpose lending
// service area. Full consumer-mortgage licensing is limited to FL and CO;
// other states are served through LLC / entity-vested business-purpose
// transactions where permitted by state law.
export const LENDING_STATE_SLUGS = new Set(states.map((s) => s.slug));

// LLC / entity is required in these states because we operate business-
// purpose only there (or the state's consumer-mortgage rules force entity
// vesting). FL and GA lean this way; KS asterisked in the internal note.
const ENTITY_REQUIRED_SLUGS = new Set(["florida", "georgia", "kansas"]);

// Where we hold a full mortgage license (consumer + business-purpose).
export const CONSUMER_LICENSED_SLUGS = new Set(["florida", "colorado"]);

export function isLendingState(slug: string | undefined | null): boolean {
  return !!slug && LENDING_STATE_SLUGS.has(slug);
}

export function requiresEntity(slug: string | undefined | null): boolean {
  return !!slug && ENTITY_REQUIRED_SLUGS.has(slug);
}

export function isConsumerLicensed(slug: string | undefined | null): boolean {
  return !!slug && CONSUMER_LICENSED_SLUGS.has(slug);
}

export function findState(slug: string): StateInfo | undefined {
  return states.find((s) => s.slug === slug);
}

export const serviceAreaStates = states;
